import { useInView } from "react-intersection-observer";
import { useNavigate } from "react-router";
import { getGAData } from "@routes/Article/utils/helpers";
import { FeedArticleData } from "@routes/Article/utils/types";
import { getEnvironment } from "@util/constant";
import { getEnvironmentDomain } from "@util/helpers";
import posthog from "posthog-js";

export const useHookUpdateUrlArticle = (
  urlPath: string,
  isNavigate: boolean,
  article: FeedArticleData,
  isChinese: boolean,
  variant?: string,
  setArticleObj?: (article: FeedArticleData) => void
) => {
  const navigate = useNavigate();

  const { ref } = useInView({
    threshold: 0.01,
    onChange: (inView) => {
      if (typeof window === "undefined") return;
      if (!inView || !isNavigate || !article?.id) return;

      if (typeof setArticleObj === "function") setArticleObj(article);

      navigate(urlPath, { preventScrollReset: true });

      // Repush the new data to dataLayer so GA will get the updated data
      window.dataLayer = window.dataLayer || [];
      (window.dataLayer as object[]).push({
        ...window._data,
        ...getGAData(article, isChinese),
        abVariant: variant || "control",
        virtual_url: urlPath,
        event: "virtual_pv",
      });

      // For PostHog tracking
      const currentUrl = getEnvironmentDomain(getEnvironment()) + urlPath;
      posthog.capture("$pageview", {
        $pathname: urlPath,
        $current_url: currentUrl,
      });
    },
  });

  return { ref };
};
